import appConfig, { API_BASE_URL } from './config/appConfig';

export default API_BASE_URL;
export { appConfig };
